import type { WorkerConsultationMechanism, WorkerConsultationStatus } from './types';

export const MECHANISM_LABEL: Record<WorkerConsultationMechanism, string> = {
  buzon: 'Buzón de sugerencias',
  reunion: 'Reunión',
  encuesta: 'Encuesta',
  comite: 'Comité SST',
};

export const STATUS_LABEL: Record<WorkerConsultationStatus, string> = {
  planificado: 'Planificado',
  realizado: 'Realizado',
  cerrado: 'Cerrado',
};

export function statusBadgeClass(status: WorkerConsultationStatus): string {
  switch (status) {
    case 'planificado':
      return 'bg-blue-100 text-blue-800';
    case 'realizado':
      return 'bg-green-100 text-green-800';
    case 'cerrado':
      return 'bg-gray-100 text-gray-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
}

export function mechanismBadgeClass(mechanism: WorkerConsultationMechanism): string {
  switch (mechanism) {
    case 'encuesta':
      return 'bg-purple-100 text-purple-800';
    case 'comite':
      return 'bg-amber-100 text-amber-800';
    default:
      return 'bg-slate-100 text-slate-800';
  }
}
